export const API_BASE_URL = `${process.env.REACT_APP_WEBAPI_URL}/api/v1`;
export const VMAPI_BASE_URL = `${process.env.REACT_APP_VMWEBAPI_URL}/api/v1`;
export const CATIMAGE_BASE_URL = `${process.env.REACT_APP_WEBAPI_URL}/images/category/`;
export const PRODCUCTIMAGE_BASE_URL = `${process.env.REACT_APP_WEBAPI_URL}/images/product/`;
export const HomeIMAGE_BASE_URL = process.env.REACT_APP_WEBAPI_URL;
export const GOOGLE_CLIENTID = process.env.REACT_APP_CLIENT_ID;
